import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft, Home } from 'lucide-react';

/**
 * FocusedLayout - Clean layout without sidebar for focused tasks
 * Used when users navigate from Super App to specific features
 */
export const FocusedLayout = ({ children, title, backPath }) => {
  const navigate = useNavigate();
  const actualBackPath = backPath || '/app/home';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      {/* Simple top bar */}
      <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(actualBackPath)}
                className="flex items-center gap-2"
                data-testid="back-button"
              >
                <ArrowLeft className="h-4 w-4" />
                <span className="hidden sm:inline">
                  {backPath ? 'Back' : 'Back to Home'}
                </span>
              </Button>
              {title && (
                <>
                  <div className="h-6 w-px bg-gray-300 dark:bg-gray-700" />
                  <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                    {title}
                  </h1>
                </>
              )}
            </div>
            
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/app/home')}
              title="Home"
            >
              <Home className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>
    </div>
  );
};
